// Shared constants mirrored from the native app (keep in sync with Models.swift).

export type Gender = "male" | "female";
export const GENDERS: { value: Gender; label: string }[] = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

// SearchRadius raw values (miles).
export const RADII = [5, 10, 25, 50, 100, 500, 1000, 2000, 3000];
export const radiusLabel = (mi: number) =>
  mi >= 1000 ? `${mi / 1000},000 mi` : `${mi} mi`;

export interface PromptAnswer {
  prompt: string;
  answer: string;
}

// Subset of PromptBank.all — sync with Models.swift when finalizing.
export const PROMPT_BANK = [
  "Two truths and a lie…",
  "The way to my heart is…",
  "My most controversial opinion is…",
  "I'm weirdly good at…",
  "We'll get along if…",
  "My ideal first date is…",
  "The last thing I got obsessed with…",
  "A green flag I look for…",
  "My simple pleasures…",
  "Don't hate me if I…",
];

export const MESSAGE_LIMIT = 10; // "Every match gets 10 messages."
export const MIN_PHOTOS = 3;
export const MAX_PHOTOS = 6;
